import React, { useState } from 'react';
// import { Link } from 'gatsby';
import './cross-menu.scss';

const CrossMenu = props => {

  const { mobile, btnOptions, isLogIn, btnActiveDefault } = props;
  const [activeSelect, setactiveSelect] = useState(false);

  return (
    <>
      {!mobile ? (
        <div className="f-cross-menu">
          <div className={process.env.LOCALE === "es-UY" ? "f-cross-menu-container--UY" : "f-cross-menu-container"}>
            <div className={"f-cross-menu-container-tags"}>
              {btnOptions.map((item, index) => {
                return (
                  <a href={'/mis-puntos' + item.slug} className="f-cross-menu-container-tags-button" key={index}>
                    <button
                      className={"f-cross-menu-container-tags-button-heart " +
                        (btnActiveDefault === index ? "f-btn primary-pink short" : "f-btn secondary-pink short")}>
                      {item.title}
                    </button>
                  </a>
                )
              })}
            </div>
          </div>
        </div>
      ) : (
          <div className="f-input-group">
            <div className={"f-input-question f-fake-select " + (isLogIn ? 'f-back-log' : '')} onClick={() =>{ setactiveSelect(!activeSelect)}}>
              <label className="f-label-inside">
                {btnOptions[btnActiveDefault].title}
              </label>
              <span onClick={e =>{e.preventDefault();e.stopPropagation(); setactiveSelect(!activeSelect)}} className={"icon-down f-icon-cross" + (activeSelect ? ' f-cross-effect' : '')} />
              {activeSelect &&
                <div className="f-collapse-menu">
                  {btnOptions.map((option, index) => {
                    return (
                      <a href={'/mis-puntos' + option.slug} className="f-item-option" key={index} >
                        {option.title}
                      </a>
                    )
                  })}
                </div>
              }
            </div>
          </div>
        )}
    </>
  )
}

export default CrossMenu;
